import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const mobexo = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            hero: {
                'title': 'Willkommen bei der Werkstatt-Buchung von {{organization}}',
                'subtitle': null,
            },
            welcomeModal: {
                'title': 'Sie verlassen nun die Seite von Mobexo',
                'text': 'Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt Mobexo nicht verantwortlich ist und die Datenschutzbestimmungen von Mobexo keine Anwendung finden.',
            },
            layout: {
                backText: 'Zurück zu mobexo.de',
            },
            linkToHome: 'https://werkstatt.repareo.de/partner/mobexo'
        },
    }
}
